import { BasicFieldInputs } from '../components/BasicFieldInputs';

export const DividerField = ({
  field,
  setField,
}: {
  field: any;
  setField: (field: any) => void;
}) => {
  return (
    <BasicFieldInputs
      fields={['title']}
      fieldValues={field}
      requiredFields={['title']}
      onChange={(key, value) => setField({ ...field, [key]: value })}
    />
  );
};
